import { render, staticRenderFns } from "./Qadministration.vue?vue&type=template&id=77bded63&scoped=true"
import script from "./Qadministration.vue?vue&type=script&lang=js"
export * from "./Qadministration.vue?vue&type=script&lang=js"
import style0 from "./Qadministration.vue?vue&type=style&index=0&id=77bded63&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bded63",
  null
  
)

export default component.exports